var map = {
	"./ico_check.svg": 22,
	"./ico_cliente.png": 23,
	"./ico_comunicacion.png": 24,
	"./ico_date.svg": 25,
	"./ico_empresa.png": 26,
	"./ico_evento.png": 27,
	"./ico_innovacion.png": 28,
	"./ico_noticia.png": 29,
	"./ico_otros.png": 30,
	"./ico_producto.png": 31,
	"./ico_proyecto.png": 32,
	"./ico_sector.png": 33,
	"./ico_servicio.png": 34,
	"./ico_video.png": 35
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;